export default "__VITE_ASSET__a46be6cc__"